import React, { FC } from 'react';
import {
  Route,
  Switch,
  useRouteMatch,
} from 'react-router-dom';

import WebTermsOfUse from '../pages/WebTermsOfUse';
import WebPointsFAQ from '../pages/WebPointsFAQ/WebPointsFAQ';

const Web: FC = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/web-terms-of-use`}>
        <WebTermsOfUse />
      </Route>
      <Route path={`${path}/web-points-faq`}>
        <WebPointsFAQ />
      </Route>
    </Switch>
  );
};

export default Web;
